// Entry del bundle del theme login facturadirecta.v3.
//
// Expone `window.fdLogin.runPage(command)` para que el template.ftl lo
// invoque con el `command` correspondiente a la pantalla que Keycloak
// quiere renderizar. Replica el contrato del bundle legacy
// `window.Keycloak.runPage` pero bajo namespace propio — ver window.ts.
//
// La inicialización imita la del legacy:
//   1. errorReporter.init() ANTES que nada para capturar errores que
//      ocurran durante el bundle mismo.
//   2. Cuando KC nos llama con runPage(command):
//      a. validDomain() — bloquea si el hostname no está en
//         fdPublicConfig.LOGIN_DOMAINS (mitiga phishing).
//      b. initTrackers() — GA4 + Intercom.
//      c. render del componente raíz.

import "./styles/main.css";
import { runPage as renderPage } from "./Login";
import { exposeFdLogin } from "./window";
import { init as initErrorReporter } from "./errorReporter";
import { initTrackers } from "./trackers";
import { validDomain } from "./validDomain";
import { msg } from "./i18n";

initErrorReporter();

function runPage(command: string) {
  if (!validDomain()) {
    // Dominio actual no está en LOGIN_DOMAINS. Causa habitual: mal
    // KEYCLOAK_FD_ENV en el contenedor (p.ej. prod contra localhost).
    // NO logueamos la lista permitida — sería pista útil para un
    // atacante intentando embeber el login en otro dominio.
    console.error(
      `[Login] Unauthorized domain: '${window.location.hostname}'`,
    );
    const el = document.getElementById("content");
    if (el) {
      // Mensaje visible mínimo. Inline-styled para no depender del CSS
      // del bundle (si algo falla aquí, CSS externo puede no haber
      // cargado tampoco).
      el.innerHTML =
        '<div style="text-align:center;margin-top:70px;font-family:Helvetica,Arial,sans-serif;font-weight:500;color:#5a646a;font-size:32px">' +
        msg("unauthorizedDomain") +
        "</div>";
    }
    return;
  }
  initTrackers();
  renderPage(command);
}

exposeFdLogin({ runPage });
